module.exports = __webpack_public_path__ + "static/homunculus_servant-059e67eaeaeba5bb7015d5cc904f67c5.png";